import React from "react";
import Select from 'react-select';
import './custom-select.scss';

export default function CustomSelect({
  description = "",
  optional = false,
  value = "",
  testid = "",
  onChange,
  options,
  styles,
  placeholder = "Select...",
}) {
  return (
    <div className="custom-text-input-field" style={styles} data-testid={testid}>
      {description && !optional && <h3>{description}</h3>}
      {description && optional && (
        <div className="optional-description">
          <h3>{description}</h3>
          <h3 className="optional-text">optional</h3>
        </div>
      )}
      <Select
        value={options.find((option) => option.value === value) || null}
        onChange={onChange}
        options={options}
        placeholder={placeholder}
        menuPlacement={"top"}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: '1px solid #C5CCF7',
            height: '44px',
            borderRadius: '5px',
            filter: 'drop-shadow(1px 1px 1px #D1D5DB);'
          }),
          input: (baseStyles, state) => ({
            ...baseStyles,
            padding: '0px',
            fontSize: '16px',
          }),
          singleValue: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: '16px',
          }),
          valueContainer: (baseStyles, state) => ({
            ...baseStyles,
            padding: '0px 5px',
            height: '100%',
          }),
          indicatorSeparator: (baseStyles, state) => ({
            ...baseStyles,
            display: 'none',
          }),
          option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: '16px',
          }),
          menuList: (baseStyles, state) => ({
            ...baseStyles,
            maxHeight: '200px',
          }),
          dropdownIndicator: (baseStyles, state) => ({
            ...baseStyles,
            color: '#5E69D2',
          }),
        }}
      />
    </div>
  );
}
